import React from 'react';
import {Box, Paper, Typography} from '@mui/material';
import {formatTime} from '../../../../../utils/formatTimestamp';

const UserMessage = ({message}) => {
    const formattedTime = formatTime(message?.createdAt);

    return (
        <Box sx={{display: 'flex', justifyContent: 'flex-end', mb: 1.5}}>
            <Box sx={{maxWidth: '70%'}}>
                <Paper
                    elevation={1}
                    sx={{
                        px: 2,
                        py: 1.5,
                        bgcolor: '#eeeeee',
                        color: '#212121',
                        borderRadius: 2,
                        borderBottomRightRadius: 4,
                        boxShadow: 'none',
                    }}
                >
                    <Typography variant="body1" sx={{whiteSpace: 'pre-wrap', wordBreak: 'break-word'}}>
                        {message.text}
                    </Typography>
                </Paper>
                <Typography variant="caption"
                            sx={{display: 'block', textAlign: 'right', mt: 0.5, color: 'text.secondary'}}>
                    {formattedTime}
                </Typography>
            </Box>
        </Box>
    );
};

export default UserMessage;

